import _ from "@lodash";
import { AppBar, DialogActions, DialogContent, Grid, IconButton, InputAdornment, Paper, Switch, Tab, Tabs, TextField, Toolbar, Typography, withStyles } from "@material-ui/core";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import ImprimirApp from "app/Core/Components/Imprimir/ImprimirApp";
import LookupApp_old from "app/Core/Components/Lookup_old/LookupApp_old";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as Helpers from "app/Core/Helpers";
import Planos from "app/Planos/index.json";
import * as AppActions from "app/store/actions";
import clsx from "clsx";
import MobileDetect from "mobile-detect";
import React from "react";
import { MdClose } from "react-icons/md";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import XAPPButton from "../../Core/Components/Button/XAPPButton";
import LogRegistro from "../../Core/Components/LogRegistro/LogRegistroApp";
import EmpresaDepositoApp from "../../ERP/EmpresaDeposito/EmpresaDepositoApp";
import EmpresaPessoaApp from "../../ERP/EmpresaPessoa/EmpresaPessoaApp";
import EmpresaProdutoApp from "../../ERP/EmpresaProduto/EmpresaProdutoApp";
import * as Actions from "./Store/Actions/TarefaApontamentoActions";
import TarefaApontamentoGeradorParcela from "./TarefaApontamentoGeradorParcela";
import TarefaApontamentoItens from "./TarefaApontamentoItens";
import TarefaApontamentoOperacao from "./TarefaApontamentoOperacao";

const styles = (theme) => ({
   paper: {
      border: "1px solid " + theme.palette.divider,
      //marginBottom: "24px",
      padding: "4px",
   },
   spanlabel: {
      top: 9,
      left: 15,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      paddingRight: 5,
      paddingLeft: 5,
      fontSize: 12.5,
      fontFamily: "Muli,Roboto,\"Helvetica\",Arial,sans-serif",
      color: theme.palette.text.secondary,
      maxWidth: "40px",
   },
   mensagem: {},
   GridItemSwitch: {
      padding: "5px 4px",
      display: "flex",
      alignItems: "center",
      color: theme.palette.text.primary,
   },
});

const md = new MobileDetect(window.navigator.userAgent);

const newTarefaApontamentoState = {
   idtarefaprocessoapontamento: null,
   idtarefaprocesso: null,
   idpessoaformulario: null,
   descricaocomercial: null,
   resumoservico: null,
   observacao: null,
   idparent: null,
   nome: null,
   parcela: null,
   valortotal: null,
   valorpendente: null,
   natureza: null,
   competencia: Helpers.GetDataAtual(null, "usa"),
   validade: Helpers.GetDataAtual(null, "usa"),
   tabValue: 0,
   status: "pendente",
   itens: [],
   aprazo: false,
};

class TarefaApontamentoNovoDialog extends XAPPComponent {

   constructor(props) {
      super(props);
      this.handleChangeItens = this._handleChangeItens.bind(this);
   }

   state = { ...newTarefaApontamentoState };

   componentDidUpdate(prevProps, prevState) {
      if (this.props.Reducer.error) {
         this.props.showMessage({
            message: this.props.Reducer.error,
            variant: "error",
         });
         this.props.Reducer.error = null;
      }
      if (this.props.Reducer.warning) {
         this.props.showMessage({
            message: this.props.Reducer.warning,
            variant: "warning",
         });
         this.props.Reducer.warning = null;
      }
      if (this.props.Reducer.info) {
         this.props.showMessage({
            message: this.props.Reducer.info,
            variant: "success",
         });
         this.props.Reducer.info = null;

         if (!_.isNull(this.props.callback) && !_.isNull(this.props.novoDialog)) {
            this.props.openNovoDialog(null);
            this.props.callback();
         }
      }

      if (_.isNull(prevProps.novoDialog) && !_.isNull(this.props.novoDialog)) {
         var obj = Object.assign({}, newTarefaApontamentoState, this.props.novoDialog);

         if ([7, 0, 1, 18, 4, 5].includes(obj.natureza)) {
            if (!_.isUndefined(this.props.pessoaformulario) && !_.isNull(this.props.pessoaformulario) && _.isNull(obj.idtarefaprocessoapontamento)) {
               obj.nome = this.props.pessoaformulario.nome;
               obj.idpessoaformulario = this.props.idpessoaformulario;
            }
         }

         if (this.props.foreingKey !== undefined) {
            obj.idtarefaprocesso = this.props.foreingKey;
         }
         this.setState(obj);
      }

      if (!_.isNull(prevProps.novoDialog) && _.isNull(this.props.novoDialog)) {
         this.setState({ ...newTarefaApontamentoState });
      }

      if (prevState.tabValue !== 1 && this.state.tabValue === 1) {
         this.props.getOperacao("SELECIONAR", this.props.xappRouteParams, this.state.idtarefaprocessoapontamento);
      }
   }

   handleChange = (event) => {
      this.setState(_.set({ ...this.state }, event.target.name, event.target.type === "checkbox" ? event.target.checked : event.target.value));
   };

   handleChangeMask = (event) => {
      this.setState(_.set({ ...this.state }, event.target.name, Helpers.ReplaceAll(event.target.value, /[^\w\s]/gi, "")));
   };

   getEmpresaDepositoLookup = (_AChange) => {
      return (
         <EmpresaDepositoApp
            xappRouteParams={this.props.xappRouteParams}
            isLookup={true}
            multiSelect={false}
            onChange={_AChange}
            id="TarefaApontamentoEmpresaDeposito"
         />
      );
   };

   handleLookupEmpresaDeposito = (_AValue) => {
      var obj = this.state;
      if (_AValue) {
         obj["idpessoaformulario"] = _AValue["idpessoaformulario"];
         obj["nome"] = _AValue["nome"];
         this.setState(obj);
      } else {
         obj["idpessoaformulario"] = null;
         obj["nome"] = null;
         this.setState(obj);
      }
   };

   getEmpresaProdutoLookup = (_AChange) => {
      return (
         <EmpresaProdutoApp
            xappRouteParams={this.props.xappRouteParams}
            isLookup={true}
            multiSelect={false}
            onChange={_AChange}
            tipo={1}
            id="TarefaApontamentoEmpresaProduto"
            filter={{ AND: [{ Campo: "tipo", Operador: "=", Valor: 2 }] }}
         />
      );
   };

   handleLookupEmpresaProduto = (_AValue) => {
      var obj = this.state;
      if (_AValue) {
         obj["idpessoaformulario"] = _AValue["idpessoaformulario"];
         obj["nome"] = _AValue["nome"];
         obj["unidademedidadescricao"] = _AValue["unidademedida"];
         obj["valor"] = _AValue["valor"];
         this.setState(obj);
      } else {
         obj["idpessoaformulario"] = null;
         obj["nome"] = null;
         obj["unidademedidadescricao"] = null;
         obj["valor"] = null;
         this.setState(obj);
      }
   };

   getEmpresaInsumoLookup = (_AChange) => {
      return (
         <EmpresaProdutoApp
            xappRouteParams={this.props.xappRouteParams}
            isLookup={true}
            multiSelect={false}
            onChange={_AChange}
            tipo={1}
            id="TarefaApontamentoEmpresaProduto"
            filter={{
               AND: [{ Campo: "tipo", Operador: "IN", Valor: "(1, 3)" }],
            }}
         />
      );
   };

   handleLookupEmpresaInsumo = (_AValue) => {
      var obj = this.state;
      if (_AValue) {
         obj["idpessoaformulario"] = _AValue["idpessoaformulario"];
         obj["nome"] = _AValue["nome"];
         obj["unidademedidadescricao"] = _AValue["unidademedida"];
         obj["valor"] = _AValue["valor"];
         this.setState(obj);
      } else {
         obj["idpessoaformulario"] = null;
         obj["nome"] = null;
         obj["unidademedidadescricao"] = null;
         obj["valor"] = null;
         this.setState(obj);
      }
   };

   handleLookupEmpresaPessoa = (_AValue = []) => {
      var obj = this.state;
      if (_AValue.length > 0) {
         obj["idpessoaformulario"] = _AValue[0].idpessoaformulario;
         obj["nome"] = _AValue[0].nome;
         this.setState(obj);
      } else {
         obj["idpessoaformulario"] = null;
         obj["nome"] = null;
         this.setState(obj);
      }
   };

   canBeSubmitted() {
      const form = this.state;
      switch (form.natureza) {
         case 0:
         case 4:
            return (
               form.idpessoaformulario !== null && form.idpessoaformulario !== "" &&
               form.valorpendente === form.valortotal
            );
         case 1:
         case 5: {
            if (_.findIndex(form.itens, { idpessoaformularioformapagamento: null }) > -1) {
               return false;
            }
            return !this.getInconsistencia();
         }
         default:
            return form.idpessoaformulario !== null && form.idpessoaformulario !== "";
      }
   }

   excluir = () => {
      this.props.remove(this.state, this.props.xappRouteParams, this.props.foreingKey);
      this.props.openNovoDialog(null);
   };

   handleChangeTab = (event, _AValue) => {
      this.setState({ tabValue: _AValue });
   };

   _handleChangeItens = (_AValue, _AAction = "ATUALIZAR") => {
      let AIndex = -1;
      let AArray = !_.isNull(this.state.itens) ? [...this.state.itens] : [];
      if (_.isNull(_AValue.desconto) || _AValue.desconto === "") {
         _AValue.desconto = 0;
      }
      if (_.isNull(_AValue.acrescimo) || _AValue.acrescimo === "") {
         _AValue.acrescimo = 0;
      }
      switch (_AAction) {
         case "ATUALIZAR":
            if (!_.isUndefined(_AValue.idtarefaprocessoapontamentoitem) && !_.isNull(_AValue.idtarefaprocessoapontamentoitem)) {
               AIndex = _.findIndex(AArray, {
                  idtarefaprocessoapontamentoitem: _AValue.idtarefaprocessoapontamentoitem,
               });
               if (AIndex !== -1) {
                  AArray.splice(AIndex, 1, _AValue);
               } else {
                  AArray.push(_AValue);
               }
            } else if (!_.isUndefined(_AValue.idtemporario) && !_.isNull(_AValue.idtemporario)) {
               AIndex = _.findIndex(AArray, {
                  idtemporario: _AValue.idtemporario,
               });
               if (AIndex !== -1) {
                  AArray.splice(AIndex, 1, _AValue);
               } else {
                  AArray.push(_AValue);
               }
            }
            break;
         case "REMOVER":
            if (!_.isUndefined(_AValue.idtarefaprocessoapontamentoitem) && !_.isNull(_AValue.idtarefaprocessoapontamentoitem)) {
               AIndex = _.findIndex(AArray, {
                  idtarefaprocessoapontamentoitem: _AValue.idtarefaprocessoapontamentoitem,
               });
               AArray.splice(AIndex, 1, {
                  ...AArray[AIndex],
                  idtarefaprocessoapontamentoitem: AArray[AIndex].idtarefaprocessoapontamentoitem * -1,
               });
            } else if (!_.isUndefined(_AValue.idtemporario) && !_.isNull(_AValue.idtemporario)) {
               AIndex = _.findIndex(AArray, {
                  idtemporario: _AValue.idtemporario,
               });
               AArray.splice(AIndex, 1);
            }
            break;
         default:
            break;
      }
      this.setState(_.set({ ...this.state }, "itens", AArray));
   };

   setItens = (_AValue) => {
      this.setState(_.set({ ...this.state }, "itens", _AValue));
   };

   isReadOnly = () => {
      const form = this.state;
      switch (form.natureza) {
         case 0:
            return form.aprovacao !== null;
         case 1:
            return form.status !== "pendente" && form.status !== "reprovado" && form.status !== "inativado";
         case 4:
            return form.idparent !== null && form.idparent.toString()[0] !== "-";
         case 5:
            return form.status !== "pendente" && form.status !== "reprovado" && form.status !== "inativado";
         default:
            return false;
      }
   };

   getDialogDescricao = (_ACondicao, _ATab) => {
      switch (_ATab) {
         case 0:
            return (_ACondicao ? "Novo" : "Editar") + " pedido de compra";
         case 3:
            return (_ACondicao ? "Novo" : "Editar") + " lançamento de estoque";
         case 4:
            return (_ACondicao ? "Novo" : "Editar") + " pedido de venda";
         case 1:
         case 5:
            return (_ACondicao ? "Novo" : "Editar") + " lançamento de caixa";
         case 7:
            return (_ACondicao ? "Novo" : "Editar") + " orçamento de compra";
         case 18:
            return (_ACondicao ? "Novo" : "Editar") + " orçamento de venda";
         default:
            return (_ACondicao ? "Novo" : "Editar") + " apontamento";
      }
   };

   handleCheck = (ev) => {
      this.setState(_.set({ ...this.state }, ev.target.name, ev.target.checked));
   };

   getInconsistencia = () => {
      const form = this.state;
      var AResponse = false;
      var ACount = 0;
      if (form.itens !== null) {
         form.itens.forEach((item) => {
            ACount += Number(item.valor);
         });

         if (ACount.toFixed(2) !== Number(form.valorpendente).toFixed(2)) {
            AResponse = true;
         }
      }
      return AResponse;
   };

   getDadosImpressao = (_AValue) => {
      var AResponse = _AValue;
      const { pessoaformulario, sistemas, xappRouteParams, profissional = null } = this.props;
      if (!_.isUndefined(pessoaformulario) && !_.isNull(pessoaformulario)) {
         Object.keys(pessoaformulario).forEach(key => {
            AResponse["cliente_" + key] = pessoaformulario[key];
         });
      }
      if (!_.isUndefined(sistemas[xappRouteParams.empresa]) && !_.isNull(sistemas[xappRouteParams.empresa]) && !_.isNull(sistemas[xappRouteParams.empresa].dados)) {
         var ADados = sistemas[xappRouteParams.empresa].dados;
         if (!_.isUndefined(ADados) && !_.isNull(ADados)) {
            Object.keys(ADados).forEach(key => {
               AResponse["empresa_" + key] = ADados[key];
            });
         }
      }

      if (!_.isNull(profissional) && !_.isUndefined(profissional?.formulario) && !_.isNull(profissional?.formulario)) {
         // IMOVEL ONLY
         AResponse["proprietario_nome"] = profissional.formulario.proprietario;
         AResponse["proprietario_email"] = profissional.formulario["proprietario-email"];
         // IMOVEL ONLY

         AResponse["profissional_nome"] = profissional.nome;
         AResponse["profissional_favorecido"] = profissional.formulario.favorecido;
         AResponse["profissional_dadosbancarios"] = profissional.formulario["dados-bancarios"];
      }

      AResponse["mesano"] = Helpers.getMesAno(_AValue.competencia);
      AResponse["EMISSAODESCRICAO"] = _AValue.datainsdescricao.split(" ")[0];
      return AResponse;
   };

   render() {
      const { classes, novoDialog, save, settings, xappRouteParams, FormasPagamento, foreingKey, openNovoDialog, callback, profissional } = this.props;
      const form = this.state;
      const readOnly = this.isReadOnly();
      return (
         <XAPPDialog
            id="TarefaApontamentoNovo"
            open={!_.isNull(novoDialog)}
            onClose={() => openNovoDialog(null)}
            fullWidth
            fullScreen={md.mobile() !== null}
            maxWidth={md.mobile() === null && md.tablet() === null && "md"}
         >
            <AppBar position="static" elevation={1}>
               <Toolbar className="flex w-full min-h-0">
                  <Typography variant="subtitle1 text-white">
                     {this.getDialogDescricao(_.isNull(form.idtarefaprocessoapontamento), form.natureza)}
                  </Typography>
                  {!_.isNull(novoDialog) && <LogRegistro Log={novoDialog} />}
                  <div style={{ flex: 1 }} />
                  <IconButton key="close" aria-label="Close" className="p-6" onClick={() => openNovoDialog(null)}>
                     <MdClose className="text-20 text-white" />
                  </IconButton>
               </Toolbar>
            </AppBar>
            <DialogContent classes={{ root: "px-24" }}>
               {!_.isNull(form.idtarefaprocessoapontamento) && (
                  <Tabs
                     value={form.tabValue}
                     onChange={this.handleChangeTab}
                     indicatorColor="secondary"
                     textColor="secondary"
                     variant="scrollable"
                     scrollButtons="auto"
                     classes={{ root: "w-full h-32" }}
                  >
                     <Tab className="h-32 normal-case" label="Geral" />
                     {/* <Tab className="h-32 normal-case" label="Histórico" /> */}
                  </Tabs>
               )}
               {form.tabValue === 0 && (
                  <React.Fragment>
                     <div className="flex w-full flex-wrap lg:flex-no-wrap">
                        <div className="mt-12 w-full">
                           {[2, 3, 15, 16].includes(form.natureza) && (
                              <LookupApp_old
                                 className="w-full flex flex-col mt-8 mb-12"
                                 instancia={this.getEmpresaDepositoLookup}
                                 selected={
                                    form.idpessoaformulario !== null
                                       ? [
                                          {
                                             id: form.idpessoaformulario,
                                             label: form.nome,
                                          },
                                       ]
                                       : ""
                                 }
                                 label="Depósito"
                                 id="LookupTarefaProcessoApontamentoEmpresaDeposito"
                                 campoid="idpessoaformulario"
                                 onChange={this.handleLookupEmpresaInsumo}
                                 required
                                 readOnly={readOnly || form.idtarefaprocessoapontamento !== null}
                              />
                           )}
                           {[1, 4, 5, 6, 18].includes(form.natureza) && (
                              <EmpresaPessoaApp
                                 className="w-full flex flex-col mt-8 mb-12"
                                 xappRouteParams={xappRouteParams}
                                 selected={
                                    form.idpessoaformulario !== null
                                       ? [
                                          {
                                             id: form.idpessoaformulario,
                                             idpessoaformulario: form.idpessoaformulario,
                                             nome: form.nome,
                                             label: form.nome,
                                          },
                                       ]
                                       : []
                                 }
                                 label="Pessoa"
                                 id="LookupTarefaProcessoApontamentoEmpresaPessoa"
                                 onChange={this.handleLookupEmpresaPessoa}
                                 required={true}
                                 isLookup={true}
                                 multiSelect={false}
                                 readOnly={readOnly || form.natureza === 1 || form.natureza === 5 || form.idtarefaprocessoapontamento !== null}
                              />
                           )}
                           {[0, 7].includes(form.natureza) && (
                              <EmpresaPessoaApp
                                 className="w-full flex flex-col mt-8 mb-12"
                                 xappRouteParams={xappRouteParams}
                                 selected={
                                    form.idpessoaformulario !== null
                                       ? [
                                          {
                                             id: form.idpessoaformulario,
                                             idpessoaformulario: form.idpessoaformulario,
                                             nome: form.nome,
                                             label: form.nome,
                                          },
                                       ]
                                       : []
                                 }
                                 label="Fornecedor"
                                 id="LookupTarefaProcessoApontamentoEmpresaPessoaFornecedor"
                                 onChange={this.handleLookupEmpresaPessoa}
                                 required={true}
                                 isLookup={true}
                                 multiSelect={false}
                                 readOnly={readOnly || form.idtarefaprocessoapontamento !== null}
                              />
                           )}
                           <div className="flex w-full flex-wrap lg:flex-no-wrap flex-row">
                              {[0, 4].includes(form.natureza) && (
                                 <TextField
                                    className="mb-12 lg:mr-8"
                                    label="Validade"
                                    id="validade"
                                    name="validade"
                                    variant="outlined"
                                    fullWidth
                                    value={form.validade}
                                    onChange={this.handleChange}
                                    disabled={readOnly}
                                    type="date"
                                    InputLabelProps={{
                                       shrink: true,
                                    }}
                                 />
                              )}
                              {[0, 2, 4].includes(form.natureza) && (
                                 <TextField
                                    className="mb-12"
                                    label="Competência"
                                    id="competencia"
                                    name="competencia"
                                    variant="outlined"
                                    fullWidth
                                    value={form.competencia}
                                    onChange={this.handleChange}
                                    disabled={readOnly}
                                    type="date"
                                    InputLabelProps={{
                                       shrink: true,
                                    }}
                                 />
                              )}
                           </div>
                           {[1, 5].includes(form.natureza) && (
                              <TextField
                                 className="mb-12 lg:mr-8"
                                 label="Valor total"
                                 id="valorpendente"
                                 name="valorpendente"
                                 variant="outlined"
                                 fullWidth
                                 value={form.valorpendente}
                                 onChange={ev => {
                                    if (Number(ev.target.value) <= form.valortotal) {
                                       this.handleChange(ev);
                                    }
                                 }}
                                 disabled={readOnly}
                                 type="number"
                                 InputLabelProps={{
                                    shrink: true,
                                 }}
                                 InputProps={{
                                    startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                                    endAdornment: this.getInconsistencia() && (
                                       <InputAdornment position="start">
                                          <XAPPButton
                                             tooltip={{ "title": "Soma das parcelas diferente do valor total, verifique!", "placement": "top" }}
                                             type="Icon"
                                             className="text-yellow p-px ml-12"
                                             iconProps="text-24"
                                             noHover
                                             onClick={() => { }}
                                             icon={"warning"}
                                          />
                                       </InputAdornment>
                                    )
                                 }}
                              />
                           )}
                           <div className="flex w-full flex-wrap lg:flex-no-wrap flex-row">
                              {[1, 5].includes(form.natureza) && (
                                 <Paper
                                    className={clsx(classes.paper, "flex w-full flex-wrap lg:flex-no-wrap px-12 justify-center mb-12")}
                                    elevation={0}
                                    rounded={true}
                                 >
                                    <div className="flex mx-8 flex-col gap-4 w-full hidden">
                                       <Typography className="font-medium" variant="">
                                          {`Valor total: R$ ${(!_.isNull(form.valortotal) ? Number(form.valortotal).toFixed(2) : "0,00")} `}
                                       </Typography>
                                       <Typography className="font-medium" variant="">
                                          {`Valor pendente: R$ ${(!_.isNull(form.valorpendente) ? Number(form.valorpendente).toFixed(2) : "0,00")} `}
                                       </Typography>
                                    </div>
                                    <div className="flex flex-row">
                                       <div className={classes.GridItemSwitch}>
                                          <Grid item>À vista</Grid>
                                       </div>
                                       <Grid component="label" alignItems="center" spacing={1} className="flex">
                                          <Grid item>
                                             <Switch onChange={this.handleCheck} name={"aprazo"} value={form.aprazo} checked={form.aprazo} />
                                          </Grid>
                                       </Grid>
                                       <div className={classes.GridItemSwitch}>
                                          <Grid item>A prazo</Grid>
                                       </div>
                                    </div>
                                 </Paper>
                              )}
                           </div>
                        </div>
                        {[1, 5].includes(form.natureza) && (
                           <TarefaApontamentoGeradorParcela
                              className="my-12 ml-12 w-full"
                              Apontamento={{ ...form, valortotal: form.valorpendente }}
                              aprazo={form.aprazo}
                              setItens={this.setItens}
                              xappRouteParams={xappRouteParams}
                              FormasPagamento={FormasPagamento}
                           />
                        )}
                     </div>
                     <div className="flex w-full flex-wrap lg:flex-no-wrap flex-row">
                        {[0, 4, 7, 18].includes(form.natureza) && (
                           <TextField
                              className="mb-12 lg:mr-8"
                              label="Condições comerciais"
                              id="descricaocomercial"
                              name="descricaocomercial"
                              variant="outlined"
                              fullWidth
                              value={form.descricaocomercial}
                              onChange={this.handleChange}
                              disabled={readOnly}
                              multiline
                              InputLabelProps={{
                                 shrink: true,
                              }}
                           />
                        )}
                        <TextField
                           className="mb-12"
                           label="Observações"
                           id="observacao"
                           name="observacao"
                           variant="outlined"
                           fullWidth
                           value={form.observacao}
                           onChange={this.handleChange}
                           disabled={readOnly}
                           multiline
                           InputLabelProps={{
                              shrink: true,
                           }}
                        />
                     </div>
                     {(![1, 5].includes(form.natureza) || (!_.isNull(form.itens) && form.itens.length > 0)) &&
                        <TarefaApontamentoItens
                           Apontamento={form}
                           handleChangeItens={this.handleChangeItens}
                           xappRouteParams={xappRouteParams}
                           profissional={profissional}
                        />
                     }
                  </React.Fragment>
               )}

               {form.tabValue === 1 && form.idtarefaprocessoapontamento !== null && <TarefaApontamentoOperacao />}
            </DialogContent>
            <AppBar position="static" elevation={3} color="textSecondary">
               <Toolbar className="flex w-full justify-end min-h-0">
                  <DialogActions>
                     {!readOnly && !_.isNull(form.idtarefaprocessoapontamento) && (
                        <XAPPButton
                           type="Button"
                           className="bg-grey-darker hover:bg-grey-darker text-white"
                           variant="contained"
                           color="primary"
                           disabled={!this.canBeSubmitted()}
                           onClick={() => {
                              save("INATIVAR", form, xappRouteParams, foreingKey);
                              openNovoDialog(null);
                              if (!_.isNull(callback)) {
                                 callback();
                              }
                           }}
                           iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                           icon={"block"}
                           label={md.mobile() === null && md.tablet() === null ? "INATIVAR" : ""}
                        />
                     )}
                     {!readOnly && [1, 5].includes(form.natureza) && form.status === "reprovado" && (
                        <XAPPButton
                           type="Button"
                           className="bg-red hover:bg-red text-white"
                           variant="contained"
                           color="primary"
                           disabled={!this.canBeSubmitted()}
                           onClick={() => {
                              save("CANCELAR", this.state, xappRouteParams, foreingKey);
                              openNovoDialog(null);
                              if (!_.isNull(callback)) {
                                 callback();
                              }
                           }}
                           iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                           icon={"close"}
                           label={md.mobile() === null && md.tablet() === null ? "CANCELAR" : ""}
                        />
                     )}
                     {[4].includes(form.natureza) && form.idtarefaprocessoapontamento !== null && (
                        <ImprimirApp
                           type="Button"
                           xappRouteParams={this.props.xappRouteParams}
                           data={JSON.stringify(this.getDadosImpressao(form))}
                           key="btnImprimir"
                           id="btnImprimir"
                           label={"Pedido"}
                           idrelatorio={Number(this.getDicionario("impressao_pedido", "113"))}
                           className="bg-blue hover:bg-blue text-white"
                        />
                     )}
                     {[0, 7, 18].includes(form.natureza) && !readOnly && form.idtarefaprocessoapontamento !== null && form.aprovacao === null && (
                        <ImprimirApp
                           type="Button"
                           data={JSON.stringify(this.getDadosImpressao(form))}
                           key="btnImprimir"
                           id="btnImprimir"
                           label={"Orçamento"}
                           column={[]}
                           className="bg-blue hover:bg-blue text-white"
                        />
                     )}
                     {!readOnly &&
                        form.status !== "inativado" &&
                        (form.idtarefaprocessoapontamento === null ? (
                           <XAPPButton
                              type="Button"
                              className="bg-green hover:bg-green text-white"
                              variant="contained"
                              color="primary"
                              disabled={!this.canBeSubmitted()}
                              onClick={() => {
                                 save("INSERIR", { ...this.state, }, xappRouteParams, foreingKey, { "conferencia-caixa": Helpers.checkPlano(Planos.financeiro.caixa, settings) });
                              }}
                              iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                              icon={"save"}
                              label={md.mobile() === null && md.tablet() === null ? "SALVAR" : ""}
                           />
                        ) : (
                           <XAPPButton
                              type="Button"
                              className="bg-green hover:bg-green text-white"
                              variant="contained"
                              color="primary"
                              disabled={!this.canBeSubmitted()}
                              onClick={() => {
                                 save("ATUALIZAR", { ...this.state, }, xappRouteParams, foreingKey, { "conferencia-caixa": Helpers.checkPlano(Planos.financeiro.caixa, settings) });
                              }}
                              iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                              icon={"save"}
                              label={md.mobile() === null && md.tablet() === null ? "SALVAR" : ""}
                           />
                        ))}
                  </DialogActions>
               </Toolbar>
            </AppBar>
         </XAPPDialog>
      );
   }
}

function mapDispatchToProps(dispatch) {
   return bindActionCreators(
      {
         list: Actions.list,
         getOperacao: Actions.getOperacao,
         openNovoDialog: Actions.openNovoDialog,
         save: Actions.save,
         remove: Actions.remove,
         showMessage: AppActions.showMessage,
         hideMessage: AppActions.hideMessage,
      },
      dispatch
   );
}

function mapStateToProps({ TarefaApontamento, auth, EmpresaFormaPagamento }) {
   return {
      Reducer: TarefaApontamento,
      novoDialog: TarefaApontamento.novoDialog,
      sistemas: auth.user.data.settings.sistemas,
      settings: auth.user.data.settings,
      FormasPagamento: EmpresaFormaPagamento?.data,
   };
}

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(TarefaApontamentoNovoDialog));
